import type { CSSProperties, ReactNode } from "react";

type RuntimeCarouselTrackProps = {
  children: (attributes: { style: CSSProperties }) => ReactNode;
  dragOffset: number;
  page: number;
};

/** Applies the page-dependent transform for the product-owned carousel. */
export function RuntimeCarouselTrack({ children, dragOffset, page }: RuntimeCarouselTrackProps): ReactNode {
  return children({ style: { transform: `translate3d(calc(-${page * 100}% + ${dragOffset}px), 0, 0)` } });
}
